import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../firebase';
import { collection, getDocs } from 'firebase/firestore';
import styles from './Home.module.css';
import hanumatImage from './image/hanumat1.png';
import homeHeroImg from './image/prrepx_home_0.png';
import homeJpg from './image/home03.png';

import Footer from "./Footer";
import PrepXFAQ from './faq.jsx'

import SocialSidebar from "../components/SocialSideBar";

const Home = () => {
  const [lectures, setLectures] = useState([]);
  const [showAllLinks, setShowAllLinks] = useState(false);
  const whyScrollRef = useRef(null);
  const [activeDot, setActiveDot] = useState(0);
  const TOTAL_WHY_CARDS = 4;

  const courseScrollRef = useRef(null);
  const [activeCoursesDot, setActiveCoursesDot] = useState(0);
  const TOTAL_COURSE_CARDS = 3;

  const courseIntervalRef = useRef(null);
  const whyIntervalRef = useRef(null);

  const [showAllServices, setShowAllServices] = useState(false);

  const slideCourse = (idx) => {
    const bounded = ((idx % TOTAL_COURSE_CARDS) + TOTAL_COURSE_CARDS) % TOTAL_COURSE_CARDS;
    const el = courseScrollRef.current;
    if (el) {
      const cards = el.querySelectorAll('[data-course-card]');
      if (cards[bounded]) el.scrollTo({ left: cards[bounded].offsetLeft, behavior: 'smooth' });
    }
    setActiveCoursesDot(bounded);
    if (courseIntervalRef.current) clearInterval(courseIntervalRef.current);
    courseIntervalRef.current = setInterval(() => {
      setActiveCoursesDot(prev => {
        const next = (prev + 1) % TOTAL_COURSE_CARDS;
        const el2 = courseScrollRef.current;
        if (el2) {
          const c = el2.querySelectorAll('[data-course-card]');
          if (c[next]) el2.scrollTo({ left: c[next].offsetLeft, behavior: 'smooth' });
        }
        return next;
      });
    }, 10000);
  };

  const slideWhy = (idx) => {
    const bounded = ((idx % TOTAL_WHY_CARDS) + TOTAL_WHY_CARDS) % TOTAL_WHY_CARDS;
    const el = whyScrollRef.current;
    if (el) {
      const cards = el.querySelectorAll('[data-why-card]');
      if (cards[bounded]) el.scrollTo({ left: cards[bounded].offsetLeft, behavior: 'smooth' });
    }
    setActiveDot(bounded);
    if (whyIntervalRef.current) clearInterval(whyIntervalRef.current);
    whyIntervalRef.current = setInterval(() => {
      setActiveDot(prev => {
        const next = (prev + 1) % TOTAL_WHY_CARDS;
        const el2 = whyScrollRef.current;
        if (el2) {
          const c = el2.querySelectorAll('[data-why-card]');
          if (c[next]) el2.scrollTo({ left: c[next].offsetLeft, behavior: 'smooth' });
        }
        return next;
      });
    }, 10000);
  };

  // Auto-slide for Course section
  useEffect(() => {
    const el = courseScrollRef.current;
    const updateDot = () => {
      if (!el) return;
      const cards = el.querySelectorAll('[data-course-card]');
      let closest = 0, minDist = Infinity;
      cards.forEach((card, idx) => {
        const dist = Math.abs(card.offsetLeft - el.scrollLeft);
        if (dist < minDist) { minDist = dist; closest = idx; }
      });
      setActiveCoursesDot(closest);
    };
    if (el) el.addEventListener('scroll', updateDot, { passive: true });
    courseIntervalRef.current = setInterval(() => {
      setActiveCoursesDot(prev => {
        const next = (prev + 1) % TOTAL_COURSE_CARDS;
        const el2 = courseScrollRef.current;
        if (el2) {
          const c = el2.querySelectorAll('[data-course-card]');
          if (c[next]) el2.scrollTo({ left: c[next].offsetLeft, behavior: 'smooth' });
        }
        return next;
      });
    }, 10000);
    return () => {
      if (courseIntervalRef.current) clearInterval(courseIntervalRef.current);
      if (el) el.removeEventListener('scroll', updateDot);
    };
  }, []);

  // Auto-slide for Why section
  useEffect(() => {
    const el = whyScrollRef.current;
    const updateDot = () => {
      if (!el) return;
      const cards = el.querySelectorAll('[data-why-card]');
      let closest = 0, minDist = Infinity;
      cards.forEach((card, idx) => {
        const dist = Math.abs(card.offsetLeft - el.scrollLeft);
        if (dist < minDist) { minDist = dist; closest = idx; }
      });
      setActiveDot(closest);
    };
    if (el) el.addEventListener('scroll', updateDot, { passive: true });
    whyIntervalRef.current = setInterval(() => {
      setActiveDot(prev => {
        const next = (prev + 1) % TOTAL_WHY_CARDS;
        const el2 = whyScrollRef.current;
        if (el2) {
          const c = el2.querySelectorAll('[data-why-card]');
          if (c[next]) el2.scrollTo({ left: c[next].offsetLeft, behavior: 'smooth' });
        }
        return next;
      });
    }, 10000);
    return () => {
      if (whyIntervalRef.current) clearInterval(whyIntervalRef.current);
      if (el) el.removeEventListener('scroll', updateDot);
    };
  }, []);

  // (mobile hero useEffect removed — single static image used)

  useEffect(() => {
    const fetchLectures = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'lectures'));
        const lectureList = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setLectures(lectureList);
      } catch (error) {
        console.error('Error fetching lectures:', error);
      }
    };
    fetchLectures();
  }, []);

  return (
    <div className={styles.homeContainer}>
      <SocialSidebar />
      
      {/* Hero Section */}
      <div className={styles.heroSection}>
        <img src={homeJpg} alt="" className={styles.heroDesktopBg} />
        <div className={`${styles.heroGlow} ${styles.glow1}`} />
        <div className={`${styles.heroGlow} ${styles.glow2}`} />
        <div className={`${styles.heroGlow} ${styles.glow3}`} />

        {/* Mobile image — shown on mobile only, hidden on desktop/tablet */}
        <div className={styles.heroMobileImg}>
          <img src={homeHeroImg} alt="PrrepX Pathshala students" className={styles.heroMobileSlideImg} />
          <div className={styles.heroMobileImgBadge}>🎯 100% IIT/NIT &amp; top Medical Alumni Faculty</div>
        </div>

        {/* Center — text content */}
        <div className={styles.heroContent}>
          <div className={styles.heroBadgePill}>🎯 100% IIT/NIT &amp; top Medical Alumni Faculty</div>
          <h1 className={styles.heroHeading}>
            Welcome to{" "}
            <span className={styles.heroBlue}>PrrepX</span>{" "}
            <span className={styles.heroAccent}>Pathshala</span>
          </h1>
          <p className={styles.heroTagline}>
            One learning destination for{" "}<span className={styles.highlightExam}>JEE & NEET</span> and{" "}<span style={{whiteSpace:'nowrap'}}><span className={styles.highlightClass}>CBSE Classes 6–12</span></span>
            <br />Video lessons, practice, tests, study resources &amp; guidance - all in one place.
          </p>
          
          <div className={styles.heroButtons}>
            <Link to="/tutorials" className={styles.btnPrimary}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fbbf24" strokeWidth="2.5">
                <polygon points="5 3 19 12 5 21 5 3"></polygon>
              </svg>
              Start Learning
            </Link>
            <Link to="/enquiry-now" className={styles.btnOutline}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#10b981" strokeWidth="2">
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z"></path>
              </svg>
              Talk to Expert
            </Link>
          </div>
          
          <p className={styles.alumniText}>✨ Led by 100% IIT/NIT &amp; Top Medical Alumni</p>
          <p style={{ marginTop: '6px' }}>
            <Link to="/about-prrepx" className={styles.learnMoreLink}>
              Learn More About PrrepX
            </Link>
          </p>
        </div>

        <div className={styles.heroScrollHint}>
          <span>Scroll to explore</span>
          <div className={styles.scrollArrow} />
        </div>
      </div>

      {/* Stats Section */}
      <section className={styles.statsSection}>
        <div className={styles.container}>
          <div className={styles.statsGrid}>
            <div className={styles.statCard}>
              <div className={styles.statNumber}>100%</div>
              <div className={styles.statLabel}>IIT/NIT/Medical Faculty</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statNumber}>1</div>
              <div className={styles.statLabel}>Stop Solution for JEE/NEET, Class 6-12</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statNumber}>360°</div>
              <div className={styles.statLabel}>Complete Student Care</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statNumber}>∞</div>
              <div className={styles.statLabel}>Premium Resources</div>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Links Section */}
      <section className={styles.quickLinksSection}>
        <div className={styles.container}>
          <div className={styles.quickLinksWrapper}>
            <span className={styles.quickLinksLabel}>🍥 Quick Links</span>
            <div className={styles.quickLinksGrid}>
              <Link to="/tutorials" className={styles.quickLinkBtn}>Tutorials</Link>
              <Link to="/doubt-portal24*7" className={styles.quickLinkBtn}>Doubt Portal</Link>
              {/* <Link to="/confidential-support" className={styles.quickLinkBtn}>Confidential Support</Link> */}
              <Link to="/meetourteam" className={styles.quickLinkBtn}>Meet Our Team</Link>
              
              {showAllLinks && (
                <>
                  <Link to="/community-page" className={styles.quickLinkBtn}>Community Page</Link>
                  <Link to="/after12" className={styles.quickLinkBtn}>Career Guidance</Link>
                  {/* <a href="https://testseries.prrepxpathshala.live" target="_blank" rel="noopener noreferrer" className={styles.quickLinkBtn}>Test Series</a> */}
                  <Link to="/study-materials" className={styles.quickLinkBtn}>Study Materials</Link>
                  <Link to="/pyqs/yearwise" className={styles.quickLinkBtn}>PYQ Papers</Link>
                  <Link to="/iitjee-syllabus" className={styles.quickLinkBtn}>JEE Syllabus</Link>
                  <Link to="/neet-syllabus" className={styles.quickLinkBtn}>NEET Syllabus</Link>
                  <Link to="/cbse12th-syllabus" className={styles.quickLinkBtn}>Class 12th Syllabus</Link>
                  <Link to="/cbse10th-syllabus" className={styles.quickLinkBtn}>Class 10th Syllabus</Link>
                  <Link to="/careers" className={styles.quickLinkBtn}>Careers Page</Link>
                  <Link to="/enquiry-now" className={styles.quickLinkBtn}>Enquiry Now</Link>
                  
                </>
              )}
              
              <button 
                onClick={() => setShowAllLinks(!showAllLinks)} 
                className={styles.quickLinkBtnViewAll}
              >
                {showAllLinks ? 'View Less ↑' : 'View More ↓'}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className={styles.sectionWhite}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>🌟 Our Services</h2>
          <div className={styles.featuresGrid}>
            <div className={styles.featureBox}>🎓 Complete JEE/NEET Preparation </div>
            <div className={styles.featureBox}>📚 Class 11–12 (Boards + Foundations)</div>
            <div className={styles.featureBox}>🏫 Class 6–10 (Boards + Olympiad)</div>
            <div className={styles.featureBox}>❓ Doubt Support 24*7</div>
          {/* <div className={`${styles.featureBox} ${!showAllServices ? styles.featureBoxHidden : ''}`}>🌎 Premium Test: One Subscription, Complete Access Model</div> */}
            {/* <div className={`${styles.featureBox} ${!showAllServices ? styles.featureBoxHidden : ''}`}>🕰️ Free PYQ Test Series</div> */}
            <div className={`${styles.featureBox} ${!showAllServices ? styles.featureBoxHidden : ''}`}>🤝 Personal 1 on 1 Mentorship</div>
            <div className={`${styles.featureBox} ${!showAllServices ? styles.featureBoxHidden : ''}`}>💬 Counselling Support</div>
            <div className={`${styles.featureBox} ${!showAllServices ? styles.featureBoxHidden : ''}`}>📚 Career Guidance After 12th</div>
            <div className={`${styles.featureBox} ${!showAllServices ? styles.featureBoxHidden : ''}`}>🕵️ Confidential Support</div>
            <div className={`${styles.featureBox} ${!showAllServices ? styles.featureBoxHidden : ''}`}>❤️ 24/7 Student Care</div>
          </div>
          <button
            className={styles.servicesToggleBtn}
            onClick={() => setShowAllServices(prev => !prev)}
          >
            {showAllServices ? '▲ View Less' : '▼ View More'}
          </button>
        </div>
      </section>

      {/* Course Program */}
      <section className={styles.sectionGray}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>Our Course Program</h2>
          <div className={styles.sliderWrapper}>
          <button className={`${styles.sliderArrow} ${styles.sliderArrowLeft}`} onClick={() => slideCourse(activeCoursesDot - 1)} aria-label="Previous course">&#8249;</button>
          <div className={styles.courseScrollOuter} ref={courseScrollRef}>
          <div className={styles.courseProgramGrid}>
            
            <div className={styles.courseCard} data-course-card>
              <div className={styles.courseBadge}>
                <span className={styles.liveRecordedBadge}>🔴 LIVE & RECORDED</span>
              </div>
              <div className={styles.courseHeader}>
                <h3 className={styles.courseMainTitle}>JEE/NEET 2026</h3>
                <p className={styles.courseSubtitle}>Target Batch - Complete Preparation</p>
              </div>
              <div className={styles.courseFeatures}>
                <div className={styles.featureItem}>
                  <span className={styles.featureIcon}>📚</span>
                  <div>
                    <strong>Complete Coverage</strong>
                    <p>Lectures, Notes, Practice Questions, Tests, 24*7 Doubt Support, etc.</p>
                  </div>
                </div>

                <div className={styles.featureItem}>
                  <span className={styles.featureIcon}>👨‍🏫</span>
                  <div>
                    <strong>Expert Faculty</strong>
                    <p className={styles.facultyHighlight}><span>JEE: by 100% IIT faculty only</span></p>
                    <p className={styles.facultyHighlight}><span>NEET: by 100% IIT + top Medical Alumni</span></p>
                  </div>
                </div>
                
                <div className={styles.featureItem}>
                  <span className={styles.featureIcon}>🌐</span>
                  <div>
                    <strong>Available in</strong>
                    <p>Mix of Hindi &amp; English</p>
                  </div>
                </div>
                
              </div>
            </div>

            <div className={styles.courseCard} data-course-card>
              <div className={styles.courseBadge}>
                <span className={styles.liveRecordedBadge}>🔴 LIVE &amp; RECORDED</span>
              </div>
              <div className={styles.courseHeader}>
                <h3 className={styles.courseMainTitle}>CLASS 11-12</h3>
                <p className={styles.courseSubtitle}>Boards + JEE/NEET Foundation</p>
              </div>
              <div className={styles.courseFeatures}>
                <div className={styles.featureItem}>
                  <span className={styles.featureIcon}>📚</span>
                  <div>
                    <strong>Complete Coverage</strong>
                    <p>Lectures, Notes, Practice Questions, Tests, 24*7 Doubt Support, etc.</p>
                  </div>
                </div>

                <div className={styles.featureItem}>
                  <span className={styles.featureIcon}>👨‍🏫</span>
                  <div>
                    <strong>Expert Faculty</strong>
                    <p className={styles.facultyHighlight}><span>100% IIT/NIT & top Medical Alumni only</span></p>
                  </div>
                </div>

                <div className={styles.featureItem}>
                  <span className={styles.featureIcon}>🌐</span>
                  <div>
                    <strong>Available in</strong>
                    <p>Mix of Hindi &amp; English</p>
                  </div>
                </div>
                
              </div>
            </div>

            <div className={styles.courseCard} data-course-card>
              <div className={styles.courseBadge}>
                <span className={styles.liveRecordedBadge}>🔴 LIVE &amp; RECORDED</span>
              </div>
              <div className={styles.courseHeader}>
                <h3 className={styles.courseMainTitle}>CLASS 6–10</h3>
                <p className={styles.courseSubtitle}>Boards + Olympiads Preparation</p>
              </div>
              <div className={styles.courseFeatures}>
                <div className={styles.featureItem}>
                  <span className={styles.featureIcon}>📚</span>
                  <div>
                    <strong>Complete Coverage</strong>
                    <p>Lectures, Notes, Practice Questions, Tests, 24*7 Doubt Support, etc.</p>
                  </div>
                </div>
                <div className={styles.featureItem}>
                  <span className={styles.featureIcon}>👨‍🏫</span>
                  <div>
                    <strong>Expert Faculty</strong>
                    <p className={styles.facultyHighlight}><span>100% IIT/NIT & top Medical Alumni only</span></p>
                  </div>
                </div>
                <div className={styles.featureItem}>
                  <span className={styles.featureIcon}>🌐</span>
                  <div>
                    <strong>Available in</strong>
                    <p>Mix of Hindi &amp; English</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </div>
          <button className={`${styles.sliderArrow} ${styles.sliderArrowRight}`} onClick={() => slideCourse(activeCoursesDot + 1)} aria-label="Next course">&#8250;</button>
          </div>
          {/* Course dots */}
          <div className={styles.courseDots}>
            {Array.from({ length: TOTAL_COURSE_CARDS }).map((_, i) => (
              <button
                key={i}
                className={`${styles.courseDot} ${activeCoursesDot === i ? styles.courseDotActive : ''}`}
                onClick={() => {
                  const el = courseScrollRef.current;
                  if (!el) return;
                  const cards = el.querySelectorAll('[data-course-card]');
                  if (cards[i]) {
                    el.scrollTo({ left: cards[i].offsetLeft, behavior: 'smooth' });
                  }
                }}
                aria-label={`Go to course ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Section */}
      <section className={styles.sectionWhite}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>Why PrrepX Pathshala Stands Out?</h2>
          <div className={styles.sliderWrapper}>
          <button className={`${styles.sliderArrow} ${styles.sliderArrowLeft}`} onClick={() => slideWhy(activeDot - 1)} aria-label="Previous">&#8249;</button>
          <div className={styles.whyScrollOuter} ref={whyScrollRef}>
          <div className={styles.whyChooseGrid}>
            <div className={styles.whyCard} data-why-card>
              <div className={styles.whyIcon}>🌟</div>
              <div className={styles.whyStat}>100% Faculty from</div>
              <h3>IIT/NIT & Top Medical Alumni</h3>
              <ul className={styles.whyCardList}>
                <li>JEE: 100% IIT faculty only</li>
                <li>Medical: 100% IIT & top medical alumni only</li>
                <li>Class 6–12: 100% IIT/NIT & top Medical alumni only</li>
                <li>Every word of content by real experts — no compromises</li>
              </ul>
            </div>
            <div className={styles.whyCard} data-why-card>
              <div className={styles.whyIcon}>🎓</div>
              <div className={styles.whyStat}>World Class</div>
              <h3>Free Contents for Everyone</h3>
              <ul className={styles.whyCardList}>
                <li>100% full syllabus — completely free</li>
                <li>Free video lectures, practice sheets (DPP), Infinite Premium Study Materials, PYQ Papers</li>
                <li>24x7 Doubt Portal — free & public for every student</li>
                <li>At par with any top paid coaching in India</li>
              </ul>
            </div>
            {/*
            <div className={styles.whyCard} data-why-card>
              <div className={styles.whyIcon}>📚</div>
              <div className={styles.whyStat}>High Quality</div>
              <h3>Free & Premium Test Series</h3>
              <ul className={styles.whyCardList}>
                <li>500+ free mock tests</li>
                <li>Covers JEE Mains, JEE Adv. & NEET</li>
                <li>One Subscription, Complete Access Model Premium Tests</li>
                <li>All created by 100% IIT/NIT & top Medical Alumni</li>
              </ul>
            </div>*/}
            <div className={styles.whyCard} data-why-card>
              <div className={styles.whyIcon}>🚀</div>
              <div className={styles.whyStat}>360°</div>
              <h3>Complete Student Care</h3>
              <ul className={styles.whyCardList}>
                {/* <li>Confidential Support — safe & private space</li> */}
                <li>Counselling Portal — data-driven & accurate</li>
                <li>Career Guidance — after 12th, for every student</li>
                <li>Personal 1-on-1 Mentorship & Guidance</li>
                <li>Truly a One-Stop Solution for every student</li>
              </ul>
            </div>
          </div>
          </div>
          <button className={`${styles.sliderArrow} ${styles.sliderArrowRight}`} onClick={() => slideWhy(activeDot + 1)} aria-label="Next">&#8250;</button>
          </div>
          {/* Scroll dots – mobile/tablet only */}
          <div className={styles.whyDots}>
            {Array.from({ length: TOTAL_WHY_CARDS }).map((_, i) => (
              <button
                key={i}
                className={`${styles.whyDot} ${activeDot === i ? styles.whyDotActive : ''}`}
                onClick={() => {
                  const el = whyScrollRef.current;
                  if (!el) return;
                  const cards = el.querySelectorAll('[data-why-card]');
                  if (cards[i]) {
                    el.scrollTo({ left: cards[i].offsetLeft, behavior: 'smooth' });
                  }
                }}
                aria-label={`Go to card ${i + 1}`}
              />
            ))}
          </div>
          <div className={styles.sectionLearnMore}>
            <Link to="/about-prrepx" className={styles.learnMoreLink}>
              Learn More About PrrepX
            </Link>
          </div>
        </div>
      </section>

      {/* Mentor Section */}
      <section className={styles.mentorSection}>
        <div className={styles.container}>
          <div className={styles.mentorFlex}>
            <div className={styles.mentorImageContainer}>
               <img src={hanumatImage} alt="Hanumat Lal Vishwakarma" className={styles.mentorImage} />
            </div>
            <div className={styles.mentorDetails}>
              <h2 className={styles.mentorTitle}>Founder & Managing Director</h2>
              <h3 className={styles.mentorName}>Hanumat Lal Vishwakarma</h3>
              <ul className={styles.mentorPoints}>
                <li>💻 Software Engineer at <strong>Rakuten Group Inc. – Tokyo, Japan</strong>.</li>
                <li>🎓 M.Tech (CSE) – <strong>IIT Ropar</strong> | B.Tech (CSE) – <strong>NIT Manipur</strong>.</li>
                <li>🎯 Qualified <strong>GATE, JEE, BHU UET, UPSEE, MMMUT</strong> & more.</li>
                <li>🏆 Got Offers of admission from IIT Ropar, IIT Jodhpur, NIT Trichy, NIT Surathkal, NIT Warangal, IIIT Delhi, IIIT Banglore, BITS Pilani, NIT Manipur & other top universities</li>
                <li>📖 Passionate Educator & Mentor with Vision to Democratize Education.</li>
                <li>💎 <a href="https://wenvhlv.vercel.app" className={styles.textLink}>Founder's Personal Page</a></li>
              </ul>
              <blockquote className={styles.mentorQuote}>
                "Led by IIT/NIT alumni, We are on a mission to empower every Indian student with <strong>premium, world-class education</strong> for <strong>JEE, NEET, Olympiads, and Class 6–12 board exams</strong>. Our vision is simple — to make <strong>excellence accessible</strong> to every learner. Even a zero finacial background students will now be able to access equally good resources without any barrier."
              </blockquote>
            </div>
          </div>
        </div>
      </section>

      {/* Vision */}
      <section className={styles.sectionWhite}>
        <div className={styles.container}>
          <h2 className={styles.sectionHeading}>🌟 Our Core Principles & Vision</h2>
          <div className={styles.visionBox}>
            <p>
                We envision an India where financial background never dictates academic success. 
                <strong>PrrepX Pathshala</strong> is designed as <strong>India’s most equitable learning ecosystem</strong>—leveling the playing field so every student gets an equal opportunity to realize their highest potential.
              </p>
              <p>
                <strong>100% Free. 100% Comprehensive. Zero Compromise.</strong> Every aspirant receives complete, end-to-end curriculum coverage matching the standard of premier paid institutes. Our entire prep framework for <strong>JEE, NEET, and Classes 6–12</strong> is conceptualized and delivered exclusively by top <strong>IIT, NIT, and Medical alumni</strong>.
              </p>
          {/* <p>We cover <strong>every mode of learning</strong> — Recorded lectures (YouTube & website), Live Classes (online), and Offline classes — so every student, anywhere in India, can prepare the way that works best for them. 🚀</p> */}
          </div>
          <div className={styles.sectionLearnMore}>
            <Link to="/about-prrepx" className={styles.learnMoreLink}>
              Learn More About PrrepX
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section - Doubt Portal */}
      <section className={styles.ctaSection}>
        <div className={styles.container}>
          <div className={styles.ctaContent}>
            <div className={styles.ctaText}>
              <span className={styles.ctaBadge}>💬 24×7 Doubt Support – First in India</span>
              <h2>Stuck on Any Questions <span className={styles.ctaHighlight}>at 12am?</span></h2>
              <p>Never feel alone. For the <strong>first time in India</strong>, our doubt support is <strong>free and public for every student</strong> — whether you're enrolled with us or not. Ask questions, get answers, and grow — any hour of the day.</p>
              <div className={styles.ctaStatsRow}>
                <div className={styles.ctaStat}><span>100%</span>IIT/NIT Faculty</div>
                <div className={styles.ctaStatDiv}></div>
                <div className={styles.ctaStat}><span>24×7</span>Support</div>
                <div className={styles.ctaStatDiv}></div>
                <div className={styles.ctaStat}><span>10k+</span>Students</div>
              </div>
              <Link to="/doubt-portal24*7" className={styles.btnSecondary}>Open Doubt Portal →</Link>
            </div>
            <div className={styles.ctaVisual}>
              <div className={styles.ctaCardStack}>
                <div className={styles.ctaVisualCard}>
                  <span className={styles.ctaVisualIcon}>❓</span>
                  <div className={styles.ctaVisualCardText}><strong>Ask Anytime</strong><p>Post Questions anytime, any topic</p></div>
                </div>
                <div className={styles.ctaVisualCard}>
                  <span className={styles.ctaVisualIcon}>⚡</span>
                  <div className={styles.ctaVisualCardText}><strong>Fast Answers</strong><p>Solved by your peers and our expert members</p></div>
                </div>
                <div className={styles.ctaVisualCard}>
                  <span className={styles.ctaVisualIcon}>👥</span>
                  <div className={styles.ctaVisualCardText}><strong>Open for Every Student</strong><p>Join thousands of peers from across India</p></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className={styles.contactFooterSection}>
        <div className={styles.container}>
          <div className={styles.contactContent}>
            
            <div className={styles.contactText}>
              <span className={styles.ctaBadge}>📲 We're Here for You</span>
              <h1>Enquiry or Request <span className={styles.ctaHighlight}>a Call Back!</span></h1>
              <p>Send an enquiry or request a call back. One of our team members will call or message you shortly.</p>
              <Link to="/enquiry-now" className={styles.btnPrimary}>Enquiry Now →</Link>
            </div>
            <div className={styles.contactVisual}>
              <div className={styles.contactChannels}>
                <div className={styles.contactChannel}><span>📞</span><strong>Phone Call</strong></div>
                <div className={styles.contactChannel}><span>💬</span><strong>WhatsApp</strong></div>
                <div className={styles.contactChannel}><span>📧</span><strong>Email</strong></div>
                <div className={styles.contactChannel}><span>📱</span><strong>Message</strong></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <PrepXFAQ />
      <Footer />
    </div>
  );
};

export default Home;
